module.exports = __webpack_public_path__ + "static/media/211IT002.31ad5580.jpeg";